import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCustomerId } from '../../services/authentication/hooks/user';
import strings from './documents.translations';
import { useCreateFolder } from '../../services/graph/hooks/onedrive';
import { ModalWithHeader } from '../../components/modal/ModalWithHeader';
import { TextInput } from '../../components/form/TextInput';
import { Button } from '../../components/button/Button';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const CreateSectionModal: FC<Props> = ({ open, onClose }) => {
  const myDirectory = useCustomerId();
  const navigate = useNavigate();

  const [folderName, setFolderName] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    // After closing the modal, clear the folder name field and error.
    if (!open) {
      // Need to do this in a set timeout- otherwise, the clear can happen before the modal closes.
      setTimeout(() => {
        setFolderName('');
        setErrorMessage('');
      }, 1000);
    }
  }, [open]);

  const { mutateAsync: createFolder, isLoading } = useCreateFolder();

  const onCreate = async () => {
    if (!folderName) {
      setErrorMessage(strings.createSection.error.noName);
      return;
    }

    const result = await createFolder({ parentId: myDirectory, newFolderName: folderName });

    if (result) {
      navigate(`sections/${result.id}`);
    } else {
      setErrorMessage(strings.createSection.error.general);
    }
  };

  return (
    <ModalWithHeader className="min-w-[350px]" open={open} onClose={onClose} title={strings.createSection.title}>
      <TextInput
        value={folderName}
        onChange={setFolderName}
        name={strings.createSection.name}
        placeholder={strings.createSection.name}
      />
      {errorMessage && <p className="text-secondary-800">{errorMessage}</p>}
      <div className="flex items-center gap-5 mt-2">
        <Button className="flex-1" onClick={onClose}>
          {strings.common.cancel}
        </Button>
        <Button primary className="flex-1" onClick={onCreate} loading={isLoading}>
          {strings.common.create}
        </Button>
      </div>
    </ModalWithHeader>
  );
};
